import type { UserFE } from 'domain/systemAdmin';

export const getUserFullName = (user?: Pick<UserFE, 'firstName' | 'lastName'>) =>
    user ? `${user.firstName} ${user.lastName}` : undefined;
